import Slider from "react-slick";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {Helmet} from 'react-helmet';
import HomeSlider from "../homeslider";
import PopularFlights from "../PopularFlights";

import AboutUs from "../AboutUs";
import Faqs from "../Faqs";
import Newsletter from "../Newsletter";
import PopularFlightsRoutes from "../PopularFlightsRoutes";
import PopularHotels from "../Hotels/Component/PopularHotels";
import BookTickets from "../BookTickets";
import FlightDestinations from "../FlightDestinations";
import PopularAirlines from "../PopularAirlines";
import FlightsFrom from "../FlightsFrom";
import FlightsWidgit from "../FlightsWidgit";
import CheapFlights from "../CheapFlights";
import Badge from "../Badge";

function App1() {
  return (
   <>

    <Helmet>     
      <title>Cheap Flights to Tucson, Lowest Airfare and offers | cheapflightsprices.com</title>
<meta name="description" content="Book Cheap Flights to Tucson with Cheapflightsprices. Grab low cost tickets & Cheap Flights to Tucson. Book now and save big with us."/>
<meta name="keywords" content="Cheapflightsprices, Cheap Flights Prices,cheap flights to tucson,cheap flights to tucson az,cheap flights to tucson from lax,cheap flights to tucson from denver,cheap flights to tucson from chicago,cheap flights to tucson from san diego,cheap flights to tucson from toronto,cheap flights to tucson from seattle,cheap flights to tucson from dallas"/>
<meta property="og:title" content="Cheap Flights to Tucson, Lowest Airfare and offers | cheapflightsprices.com" />
<meta property="og:description" content="Book Cheap Flights to Tucson with Cheapflightsprices. Grab low cost tickets & Cheap Flights to Tucson. Book now and save big with us." />
<meta property="og:site_name" content="Cheap Flights to Tucson, Lowest Airfare and offers | cheapflightsprices.com" />
<meta name="twitter:title" content="Cheap Flights to Tucson, Lowest Airfare and offers | cheapflightsprices.com" />
<meta name="twitter:description" content="Book Cheap Flights to Tucson with Cheapflightsprices. Grab low cost tickets & Cheap Flights to Tucson. Book now and save big with us." />
<link rel="canonical" href="https://cheapflightsprices.com/flights/cheap-flights-to-tucson-tus.html" />
</Helmet>

   <section id="banner_section">
    <div className="hero-container" data-aos="zoom-in" data-aos-delay="100">
      <h1 className="mb-2 pb-0">Cheap Flights to Tucson</h1>
      <h2>Cheap Flights Prices Booking Start @ $24</h2>
      <FlightsWidgit/>
      
    </div>
  </section>
<Badge/>


    <main id="main">
    <PopularFlights/>
    <FlightDestinations/>
    <PopularAirlines/>
    <PopularFlightsRoutes />
    <PopularHotels />
    <FlightsFrom/>
    <section id="Cheapflights" className="section-with-bg">
    <div className="container" data-aos="fade-up">
        <div className="section-header">
          <h2><strong>Cheap Flights to Tucson</strong></h2>
          <p></p>
        </div>
        <div className="designcontainer">
         
        </div>
      </div>
    </section>
    <Faqs/>
    <Newsletter/>
    
      </main>
  
    </>
  );
}
export default App1;
